const geGAFromCategory = (categoryId) => {
  switch (categoryId) {
    case 1:
      return {
        eventName: 'rental_lead',
        eventLabel: 'Rental Lead',
      };

    default:
      return {
        eventName: 'tour_lead',
        eventLabel: 'Tour Lead',
      };
  }
};

export default geGAFromCategory;
